const byAuthorItems = [
  { value: "specificUser", label: "Specific users..." },
  { value: "me", label: "Me" },
];
export default byAuthorItems;